import React, { useContext } from "react";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { IAssemblyAttendances } from "src/stores/assemblies/AttendanceListStore";

const AttendanceListRowMobileBase = (props: { attendances: IAssemblyAttendances }) => {
    const { attendanceListStore } = useContext(RootStoreContext);
    const { attendancestate, tenantname } = props.attendances;

    const attendanceLabel =
        attendanceListStore.attendanceStates.find((state) => state.key === attendancestate)?.label || "Unknown";

    return (
        <UI.List.Row>
            <UI.List.Cell value={tenantname} colspan={1} />
            <UI.List.Cell colspan={0.5} value={attendanceLabel} />
        </UI.List.Row>
    );
};

export const AttendanceListRowMobile = Sentry.withProfiler(observer(AttendanceListRowMobileBase));
